import QuestionMark from '@mui/icons-material/QuestionMark';
import IconButton from '@mui/material/IconButton';

import {BREAKPOINTS} from '../../../../const';
import useBreakpoint from '../../../../hooks/dom/useBreakpoint';
import useProfile from '../../../../hooks/providers/useProfile';

const HeaderOnboardingButtonIconOnly = () => {
  const {onboardingData, setIsOnboardingPopperOpen, setOnboardingPopperAnchorEl} = useProfile();
  const currentBreakpoint = useBreakpoint();
  const isExtraSmallScreen = currentBreakpoint === BREAKPOINTS.xs;

  if (!isExtraSmallScreen || onboardingData.length === 0) return null;

  return (
    <IconButton
      sx={{
        background: 'white',
        '&.MuiIconButton-root:hover': {
          background: 'white '
        }
      }}
      onClick={e => {
        setOnboardingPopperAnchorEl(e.currentTarget);
        setIsOnboardingPopperOpen(true);
      }}
      aria-label="menu aide"
      size="small"
    >
      <QuestionMark sx={{fontSize: 15}} />
    </IconButton>
  );
};

export default HeaderOnboardingButtonIconOnly;
